import axiosClient from "./AxiosConfig";

const AdminService = {

  async getAllUsers() {
    const response = await axiosClient.get(`/admin/users`);
    return response.data;
  },

  async getUserStorageUsage(userId) {
    const response = await axiosClient.get(`/admin/user/${userId}/storage-usage`);
    return response.data;
  },

  async getFamilyStorageUsage() {
    const response = await axiosClient.get(`/family/storage-usage`);
    return response.data;
  },

  async cleanOrphanedFiles() {
    return await axiosClient.get("/admin/encryption/key/aws/file/orphaned/clean");
  },

  async downloadFileArchive(userId) {
    return await axiosClient.get(`/admin/user/${userId}/files/download/archive`, {
      responseType: 'blob'
    });
  }
};

export default AdminService;
